<template>
  <div>
    <v-card-title>
      Компании
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchName"
        prepend-icon="mdi-cloud-search-outline"
        label="Поиск по названию"
        single-line
        hide-details
      ></v-text-field>
       <v-text-field
        v-model="searchBIN"
        prepend-icon="mdi-cloud-search-outline"
        label="Поиск по БИН"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="companyHeaders"
      :items="companies"
      :options.sync="options"
      class="elevation-2"
      :server-items-length="companiesCount"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 30],
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialogCompany"
            max-width="900px"
            persistent
            scrollable
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mb-2" small v-on="on" color="primary"
                >Создать</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <!-- Режим «Договоры»: та же модалка, другое содержимое (Управление → Компании → Действия → договор) -->
                <v-container v-if="agreementMode">
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="selectedAgreementId"
                        :items="agreementItems"
                        item-text="text"
                        item-value="id"
                        label="Договоры"
                        no-data-text="Договоров нет"
                        :loading="agreementLoading"
                        prepend-icon="mdi-file-document-multiple-outline"
                        clearable
                      ></v-select>
                    </v-col>
                    <v-col cols="12" class="d-flex pt-0">
                      <v-btn
                        small
                        color="primary"
                        class="mr-2"
                        :disabled="!selectedAgreementId"
                        @click="DownloadAgreement"
                      >
                        <v-icon small left>mdi-download</v-icon>Скачать
                      </v-btn>
                      <v-btn
                        small
                        color="error"
                        outlined
                        :disabled="!selectedAgreementId"
                        @click="DeleteAgreement"
                      >
                        <v-icon small left>mdi-delete</v-icon>Удалить
                      </v-btn>
                      <v-spacer></v-spacer>
                      <span class="overline align-self-center">{{ agreementCountText }}</span>
                    </v-col>
                    <v-col cols="12"><v-divider></v-divider></v-col>
                    <v-col cols="12" class="pb-0">
                      <span class="subtitle-1">Добавить договор</span>
                    </v-col>
                    <v-col cols="12">
                      <!-- Договор заключается на БИН компании (решение 21.10.2026): новый БИН у аптеки = новый договор -->
                      <v-select
                        v-model="newAgreement.bin"
                        :items="agreementBinItems"
                        item-text="text"
                        item-value="value"
                        label="БИН, на который заключён договор"
                        prepend-icon="mdi-card-account-details-outline"
                        no-data-text="У компании нет БИН — добавьте БИН в карточке компании"
                        :error-messages="newAgreement.file && !newAgreement.bin ? ['Укажите БИН'] : []"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="7" md="7">
                      <v-file-input
                        v-model="newAgreement.file"
                        accept=".doc,.docx,.txt,.pdf"
                        label="Файл договора (doc, docx, txt, pdf, до 10 МБ)"
                        show-size
                        prepend-icon="mdi-paperclip"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <v-text-field
                        v-model="newAgreement.expirationDate"
                        type="date"
                        label="Срок истечения договора"
                        persistent-hint
                        hint="Обязательно. По умолчанию +3 года"
                        :error-messages="newAgreement.file && !newAgreement.expirationDate ? ['Укажите срок истечения договора'] : []"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="d-flex pt-0">
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        color="primary"
                        :disabled="!canAddAgreement"
                        :loading="agreementLoading"
                        @click="AddAgreement"
                      >
                        <v-icon small left>mdi-plus</v-icon>Добавить
                      </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="agreementLimitReached" class="pt-0">
                      <span class="caption error--text">Достигнут лимит 10 договоров на компанию. Удалите старый, чтобы добавить новый.</span>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container v-else>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" v-show="false">
                      <v-text-field
                        v-model="editedCompany.id"
                        label="ID"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedCompany.name"
                        label="Название"
                        :error-messages="modelState['Name']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedCompany.lawName"
                        label="Юр. Название"
                        :error-messages="modelState['LawName']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedCompany.address"
                        :error-messages="modelState['Address']"
                        label="Адрес"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedCompany.website"
                        label="Веб-сайт"
                        :error-messages="modelState['Website']"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedCompany.companyCitiesId"
                        prepend-icon="mdi-city-variant-outline"
                        :items="cities"
                        menu-props="auto"
                        label="Города"
                        single-line
                        item-text="name"
                        item-value="id"
                        multiple
                        :error-messages="modelState['CompanyCitiesId']"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-select
                        v-model="editedCompany.companyTypeId"
                        :items="companyTypes"
                        prepend-icon="mdi-format-list-bulleted-type"
                        menu-props="auto"
                        label="Тип"
                        single-line
                        item-text="name"
                        item-value="id"
                        :error-messages="modelState['CompanyTypeId']"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                          v-model="editedCompany.companyFilialIds"
                          :items="filials"
                          menu-props="auto"
                          label="Филиалы"
                          single-line
                          item-text="name"
                          item-value="id"
                          multiple
                          small-chips
                          :error-message="modelState['CompanyFilialIds']"
                        ></v-autocomplete>
                    </v-col>

                    <v-row
                      v-for="(item, index) in editedCompany.companyBINs"
                      v-bind:key="index"
                    >
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          @click:append="AddBIN"
                          @click:prepend="
                            editedCompany.companyBINs.splice(index, 1)
                          "
                          :prepend-icon="
                            editedCompany.companyBINs.length > 1
                              ? 'mdi-minus'
                              : 'mdi-undefined'
                          "
                          :label="identifier"
                          required
                          maxlength="12"
                          v-model="item.bin"
                          :error-messages="
                            modelState['CompanyBINs[' + index + '].BIN']
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          @click:append="AddBIN"
                          append-icon="mdi-plus"
                          @click:prepend="
                            editedCompany.companyBINs.splice(index, 1)
                          "
                          label="Описание"
                          required
                          v-model="item.description"
                          :error-messages="modelState['CompanyBINs']"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <template v-if="agreementMode">
                  <v-btn text @click="Close" color="primary">Закрыть</v-btn>
                </template>
                <template v-else>
                  <v-btn text @click="Close" color="primary">Отмена</v-btn>
                  <v-btn text @click="Save" color="primary">Сохранить</v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.companyCities="props">
        <div
          v-for="item in props.item.companyCities"
          :key="item.id"
          class="text-no-wrap"
        >
          <span v-if="item.city">
            <v-icon x-small>mdi-city</v-icon>
            {{ item.city.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.companyBINs="props">
        <div
          v-for="item in props.item.companyBINs"
          :key="item.id"
          class="text-no-wrap"
        >
          <v-icon x-small>mdi-cube</v-icon>
          {{ item.bin }}
          <span class="overline">{{ item.description }}</span>
        </div>
      </template>

      <template v-slot:item.website="props">
        <div class="text-no-wrap">
          {{ props.item.website }}
          <v-btn small icon :href="props.item.website" target="_blank">
            <v-icon small>mdi-call-made</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.companyPhones="props">
        <div
          v-for="item in props.item.companyPhones"
          :key="item.phone"
          class="text-no-wrap"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Home'"
                >mdi-phone-classic</v-icon
              >
            </template>
            <span>Домашний</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Mobile'"
                >mdi-cellphone</v-icon
              >
            </template>
            <span>Мобильный</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Work'"
                >mdi-phone-outgoing</v-icon
              >
            </template>
            <span>Рабочий</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                x-small
                v-if="item.phoneType.phoneTypeName == 'Fax'"
                >mdi-printer</v-icon
              >
            </template>
            <span>Факс</span>
          </v-tooltip>
          {{ item.phone }}
        </div>
      </template>

      <template v-slot:item.companyEmails="props">
        <div
          v-for="item in props.item.companyEmails"
          :key="item.email"
          class="text-no-wrap"
        >
          <v-icon x-small>mdi-email</v-icon>
          {{ item.email }}
        </div>
      </template>

      <template v-slot:item.user="{ item }">
        <v-btn
          small
          @click="
            dialogUsers = !dialogUsers;
            GetUsersByCompanyId(item);
          "
        >
          <v-icon>mdi-account-group</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" title="Договоры" @click="OpenAgreements(item)">mdi-file-document-outline</v-icon>
        <v-icon small class="mr-2" @click="EditItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="DeleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogUsers"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="dialogUsers = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Имя компании</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="dialogUsers = false">Закрыть</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title>
          Пользователи
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchUsers"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="userHeaders"
          :items="users"
          :search="searchUsers"
          :items-per-page="5"
        ></v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { CitiesUzb } from "../../config";
export default {
 
  data: () => ({
    options: {
      page: 1,
      itemsPerPage: 5,
    },
    identifier: "БИН",
    companyTypes: [],
    cities: [],
    filials: [],
    modelState: {},
    editedCompany: {
      address: "",
      companyBINs: [{ bin: "", description: "" }],
      companyCitiesId: [],
      companyEmails: "",
      companyPhones: "",
      companyType: { id: 0, name: "0" },
      companyTypeId: 0,
      id: 0,
      lawName: "",
      name: "",
      website: "",
      companyFilialIds: []
    },
    defaultCompany: {
      address: "",
      companyBINs: [{ bin: "", description: "" }],
      companyCitiesId: [],
      companyEmails: "",
      companyPhones: "",
      companyType: { id: 0, name: "0" },
      companyTypeId: 0,
      id: 0,
      lawName: "",
      name: "",
      website: "",
      companyFilialIds: []
    },
    editedIndex: -1,
    // Режим «Договоры» той же модалки
    agreementMode: false,
    agreementCompany: null,
    agreements: [],
    selectedAgreementId: null,
    newAgreement: { file: null, expirationDate: "", bin: null },
    agreementLoading: false,
    users: [],
    dialogUsers: false,
    dialogCompany: false,
    companies: [],
    companiesCount: 0,
    loading: false,
    searchUsers: "",
    searchName: "",
    searchBIN: "",
    companyHeaders: [
      {
        text: "ID",
        align: "left",
        sortable: true,
        value: "id",
      },
      { text: "Название", value: "name" },
      { text: "Юр. Название", value: "lawName" },
      { text: "Город", value: "companyCities" },
      { text: "БИН", value: "companyBINs" },
      { text: "Адрес", value: "address" },
      { text: "Веб сайт", value: "website" },
      { text: "Тип компании", value: "companyType.name" },
      {
        text: "Телефоны",
        align: "center",
        sortable: true,
        value: "companyPhones",
        show: true,
      },
      {
        text: "Почты",
        align: "center",
        sortable: true,
        value: "companyEmails",
        show: true,
      },
      { text: "Пользователи", value: "user", sortable: false },
      { text: "Действия", value: "actions", sortable: false, show: true },
    ],
    userHeaders: [
      { text: "ID", sortable: true, value: "id" },
      { text: "Логин", value: "login" },
      { text: "Имя", value: "firstName" },
      { text: "Фамилия", value: "lastName" },
      { text: "Компания", value: "company.name" },
      { text: "Роль", value: "userRole.name" },
    ],
  }),
  async mounted() {
    this.GetCompanies();
    this.GetCompanyTypes();
    this.GetCities();
    this.GetFilials();
  },
  methods: {
    GetCompanies() {
      this.loading = true;

      let Pagination = {
        Take: `${this.options.itemsPerPage}`,
        Skip: `${(this.options.page - 1) * this.options.itemsPerPage}`,
      };

      let CompaniesSearchProperty = {
        Name: `${this.searchName ?? ""}`,
        BIN: `${this.searchBIN ?? ""}`,
      };

      let CompaniesSearch = {
        Pagination,
        CompaniesSearchProperty,
      };

      this.$store
        .dispatch("COMPANIES", CompaniesSearch)
        .then((response) => {
          this.companies = response.result;
          this.companiesCount = response.count;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetCompanyTypes() {
      this.$store
        .dispatch("COMPANY_TYPES")
        .then(() => {
          this.companyTypes = this.$store.getters.COMPANY_TYPES;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetCities() {
      this.$store
        .dispatch("CITIES")
        .then(() => {
          this.cities = this.$store.getters.CITIES;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    AddBIN() {
      this.editedCompany.companyBINs.push({ bin: "", description: "" });
    },
    GetUsersByCompanyId(company) {
      this.$store
        .dispatch("USERS_BY_COMPANY_ID", company.id)
        .then((response) => {
          this.users = response;
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    GetFilials() {
      this.$store
        .dispatch("FILIALS")
        .then(() => {
          this.filials = this.$store.getters.FILIALS;
        })
        .catch((error) => {
          window.console.log(error)
        });
    },
    EditItem(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.editedCompany = Object.assign({}, item);

      this.editedCompany.companyCitiesId = item.companyCities.map(
        (x) => x.cityId
      );

      this.filials = this.$store.getters.FILIALS_BY_CITIES_ID(
        this.editedCompany.companyCitiesId
      );
     
      this.editedCompany.companyFilialIds = item.companyFilials.map(
        (x) => x.filialId
      );

      if (item.companyBINs.length == 0)
        this.editedCompany.companyBINs.push({ bin: "", description: "" });

      window.console.log("  this.editedCompany", this.editedCompany);
      this.dialogCompany = true;
    },
    DeleteItem(item) {
      const index = this.companies.indexOf(item);
      confirm("Вы уверены, что хотите удалить этого пользователя?") &&
        this.companies.splice(index, 1);
    },
    Close() {
      this.modelState = {};
      this.dialogCompany = false;
      this.$nextTick(() => {
        this.editedCompany = Object.assign({}, this.defaultCompany);
        this.editedIndex = -1;
        this.CloseAgreements();
      });
    },
    // ---- Договоры компании ----
    OpenAgreements(item) {
      this.agreementCompany = item;
      this.agreementMode = true;
      this.agreements = [];
      this.selectedAgreementId = null;
      const bins = this.CompanyBins(item);
      this.newAgreement = {
        file: null,
        expirationDate: this.DefaultExpirationDate(),
        bin: bins.length === 1 ? bins[0] : null,
      };
      this.dialogCompany = true;
      this.LoadAgreements();
    },
    CloseAgreements() {
      this.agreementMode = false;
      this.agreementCompany = null;
      this.agreements = [];
      this.selectedAgreementId = null;
      this.newAgreement = { file: null, expirationDate: "", bin: null };
    },
    // Непустые БИН компании из карточки (companyBINs: [{ bin, description }])
    CompanyBins(company) {
      return ((company && company.companyBINs) || [])
        .map((x) => (x.bin || "").trim())
        .filter((x) => x.length > 0);
    },
    // Сегодня + 3 года (срок договора по ТЗ), в формате yyyy-MM-dd для <input type="date">
    DefaultExpirationDate() {
      const d = new Date();
      d.setFullYear(d.getFullYear() + 3);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${month}-${day}`;
    },
    async LoadAgreements() {
      if (!this.agreementCompany) return;
      const companyId = this.agreementCompany.id;
      this.agreementLoading = true;
      try {
        const agreements = await this.$store.dispatch("COMPANY_AGREEMENTS", companyId);
        // Устаревший ответ (быстро закрыли A и открыли B) не должен подменить договоры другой компании
        if (this.agreementCompany && this.agreementCompany.id === companyId) {
          this.agreements = agreements;
        }
      } catch (error) {
        window.console.log(error);
      } finally {
        this.agreementLoading = false;
      }
    },
    // Дублирует серверную проверку, чтобы ошибка была понятной до загрузки (иначе 11 МБ → «413» от сервера)
    ValidateAgreementFile(file) {
      const allowed = [".doc", ".docx", ".txt", ".pdf"];
      const name = (file && file.name) || "";
      const ext = name.includes(".") ? name.substring(name.lastIndexOf(".")).toLowerCase() : "";
      if (!allowed.includes(ext)) return "Допустимые форматы: doc, docx, txt, pdf";
      if (!file.size) return "Файл пустой";
      if (file.size > 10 * 1024 * 1024) return "Размер файла не более 10 МБ";
      return null;
    },
    async AddAgreement() {
      if (!this.canAddAgreement) return;
      const fileError = this.ValidateAgreementFile(this.newAgreement.file);
      if (fileError) {
        this.$store.commit("SET_SNACKBAR", { text: fileError, timeout: 5000, color: "error", show: true });
        return;
      }
      this.agreementLoading = true;
      try {
        await this.$store.dispatch("CREATE_COMPANY_AGREEMENT", {
          companyId: this.agreementCompany.id,
          bin: this.newAgreement.bin,
          expirationDate: this.newAgreement.expirationDate,
          file: this.newAgreement.file,
        });
        this.newAgreement.file = null;
        await this.LoadAgreements();
      } catch (error) {
        window.console.log(error);
      } finally {
        this.agreementLoading = false;
      }
    },
    async DeleteAgreement() {
      const agreement = this.agreements.find((x) => x.id === this.selectedAgreementId);
      if (!agreement) return;
      if (!confirm(`Удалить договор «${agreement.fileName}»?`)) return;
      this.agreementLoading = true;
      try {
        await this.$store.dispatch("DELETE_COMPANY_AGREEMENT", agreement.id);
        this.selectedAgreementId = null;
        await this.LoadAgreements();
      } catch (error) {
        window.console.log(error);
      } finally {
        this.agreementLoading = false;
      }
    },
    DownloadAgreement() {
      const agreement = this.agreements.find((x) => x.id === this.selectedAgreementId);
      if (!agreement) return;
      this.$store
        .dispatch("DOWNLOAD_COMPANY_AGREEMENT", { id: agreement.id, fileName: agreement.fileName })
        .catch((error) => window.console.log(error));
    },
    AgreementStatusText(agreement) {
      switch (agreement.status) {
        case 0:
        case "Active":
          return "действует";
        case 1:
        case "Expiring":
          return `заканчивается, ${agreement.daysLeft} дн.`;
        default:
          return "истёк";
      }
    },
    Save() {
      if (this.editedIndex > -1) {
        this.$store
          .dispatch("UPDATE_COMPANY", this.editedCompany)
          .then((response) => {
            Object.assign(this.companies[this.editedIndex], response);
            this.Close();
          })
          .catch((error) => {
            if (error.response?.data?.errors) {
              this.modelState = error.response.data.errors;
            }
            window.console.log(error);
          });
      } else {
        this.$store
          .dispatch("CREATE_COMPANY", this.editedCompany)
          .then(() => {
            this.Close();
            this.GetCompanies();
          })
          .catch((error) => {
            if (error.response?.data?.errors) {
              this.modelState = error.response.data.errors;
            }
            window.console.log(error);
          });
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.GetCompanies();
      },
      deep: true,
    },
    searchName() {
      this.GetCompanies();
    },
    searchBIN() {
      this.GetCompanies();
    },
    dialogCompany(val) {
      val || this.Close();
    },
    "editedCompany.companyCitiesId": function (val) {
      let UzbCitiesId = Object.values(CitiesUzb);

      if (val.some((x) => UzbCitiesId.includes(x))) this.identifier = "ИНН";
      else this.identifier = "БИН";
    },
  },
  computed: {
    formTitle() {
      if (this.agreementMode)
        return `Договоры компании ${this.agreementCompany ? this.agreementCompany.name : ""}`;
      return this.editedIndex === -1 ? "Новый" : "Редактировать";
    },
    agreementItems() {
      return this.agreements.map((a) => ({
        id: a.id,
        text: `${a.bin ? "БИН " + a.bin + " · " : ""}${a.fileName} — до ${this.$options.filters.toDate(String(a.expirationDate).substr(0, 10))} (${this.AgreementStatusText(a)})`,
      }));
    },
    agreementBinItems() {
      const items = this.CompanyBins(this.agreementCompany).map((bin) => ({ value: bin, text: bin }));
      const binsWithAgreement = new Set(this.agreements.map((a) => a.bin).filter(Boolean));
      return items.map((i) => ({ ...i, text: binsWithAgreement.has(i.value) ? `${i.value} (есть договор)` : i.value }));
    },
    agreementLimitReached() {
      return this.agreements.length >= 10;
    },
    canAddAgreement() {
      return (
        !!this.newAgreement.file &&
        !!this.newAgreement.bin &&
        !!this.newAgreement.expirationDate &&
        !this.agreementLimitReached &&
        !this.agreementLoading
      );
    },
    agreementCountText() {
      return `${this.agreements.length} из 10`;
    },
  },
};
</script>